import _ from 'lodash';
import { log } from '@swiper/core';
import config from '~/config';
import { Service } from './Service';

export class ConfigService extends Service {

  get name() { return 'config'; }

  async get( id, params ) {
    // Note that the get method requires an id, but we actually ignore
    // it and just use the station id for a registered station, or
    // nothing for a non-station connection.
    if ( params.station ) { // Coming from a station
      id = params.station.id;
      const station = await this.app.service( 'stations' ).get( id );
      return { ...config.station( station.type ), station };
    } else {
      return config.station();
    }
  }

}

export const hooks = {
  // before  : { all : [ 'auth' ] },
};
